// extracted by mini-css-extract-plugin
module.exports = {"rootDiv":"featuredUseCases_rootDiv__ERsX_","titleDiv":"featuredUseCases_titleDiv__y4TVJ","descriptionDiv":"featuredUseCases_descriptionDiv__8z0dj"};